import moment from 'moment-timezone'
import { MAX_PLAUSIBLE_PRESSURE_PSI, PRESSURE_STALE_AFTER_MS } from './irrigationActivityConstants'

export type TPressureReadingState = 'LIVE' | 'STALE' | 'NONE'

export type TPressureReading = {
  state: TPressureReadingState
  psi: number | null
  timestamp: string | null
}

const NO_READING: TPressureReading = { state: 'NONE', psi: null, timestamp: null }

export const getPressureReading = ({
  entry,
  nowMs,
}: {
  entry: { value: number | null; timestamp: string } | null | undefined
  nowMs: number
}): TPressureReading => {
  if (!entry || typeof entry.value !== 'number' || !Number.isFinite(entry.value)) return NO_READING

  if (Math.abs(entry.value) > MAX_PLAUSIBLE_PRESSURE_PSI) return NO_READING

  const readingMs = moment.tz(entry.timestamp, moment.ISO_8601, 'UTC').valueOf()
  const isStale = Number.isNaN(readingMs) || nowMs - readingMs > PRESSURE_STALE_AFTER_MS

  return { state: isStale ? 'STALE' : 'LIVE', psi: entry.value, timestamp: entry.timestamp }
}
